export default "__VITE_ASSET__1Hic2o27__"